import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import e from "../core/Collection.js";
import o from "../core/Error.js";
import { clone as r } from "../core/lang.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as l } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import { writer as y } from "../core/accessorSupport/decorators/writer.js";
import a from "./IconSymbol3DLayer.js";
import m from "./ObjectSymbol3DLayer.js";
import n from "./Symbol3D.js";
import c from "./TextSymbol3DLayer.js";
import { calloutProperty as p, hasVisibleCallout as b, hasVisibleVerticalOffset as u } from "./callouts/calloutUtils.js";
import f from "./support/Symbol3DVerticalOffset.js";

var _S;

var h = e.ofType({
  base: null,
  key: "type",
  typeMap: {
    icon: a,
    object: m,
    text: c
  }
}),
    j = e.ofType({
  base: null,
  key: "type",
  typeMap: {
    icon: a,
    object: m
  }
});

var d = _S = /*#__PURE__*/function (_n) {
  _inherits(S, _n);

  var _super = _createSuper(S);

  function S(t) {
    var _this;

    _classCallCheck(this, S);

    _this = _super.call(this, t), _this.verticalOffset = null, _this.callout = null, _this.symbolLayers = new h(), _this.type = "point-3d";
    return _this;
  }

  _createClass(S, [{
    key: "writeSymbolLayers",
    value: function writeSymbolLayers(t, e, r, s) {
      var l = t.filter(function (t) {
        return "text" !== t.type;
      });

      if (s && s.messages && l.length < t.length) {
        var _e = t.find(function (t) {
          return "text" === t.type;
        });

        s.messages.push(new o("symbol-layer:unsupported", "Symbol layers of type 'text' cannot be persisted in PointSymbol3D", {
          symbolLayer: _e
        }));
      }

      e[r] = l.map(function (t) {
        return t.write({}, s);
      }).toArray();
    }
  }, {
    key: "supportsCallout",
    value: function supportsCallout() {
      if ((this.symbolLayers ? this.symbolLayers.length : 0) < 1) return !1;

      var _iterator = _createForOfIteratorHelper(this.symbolLayers.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;

          switch (_t.type) {
            case "icon":
            case "text":
            case "object":
              continue;

            default:
              return !1;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !0;
    }
  }, {
    key: "hasVisibleCallout",
    value: function hasVisibleCallout() {
      return b(this);
    }
  }, {
    key: "hasVisibleVerticalOffset",
    value: function hasVisibleVerticalOffset() {
      return u(this);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _S({
        verticalOffset: r(this.verticalOffset),
        callout: r(this.callout),
        styleOrigin: r(this.styleOrigin),
        symbolLayers: r(this.symbolLayers),
        thumbnail: r(this.thumbnail)
      });
    }
  }], [{
    key: "fromSimpleMarkerSymbol",
    value: function fromSimpleMarkerSymbol(t) {
      return new _S({
        symbolLayers: [a.fromSimpleMarkerSymbol(t)]
      });
    }
  }, {
    key: "fromPictureMarkerSymbol",
    value: function fromPictureMarkerSymbol(t) {
      return new _S({
        symbolLayers: [a.fromPictureMarkerSymbol(t)]
      });
    }
  }, {
    key: "fromCIMSymbol",
    value: function fromCIMSymbol(t) {
      var e, o;
      if ("CIMPointSymbol" !== (null == (e = t.data) || null == (o = e.symbol) ? void 0 : o.type)) return null;
      return t.data.symbol.callout ? new _S({
        symbolLayers: [a.fromCIMSymbol(t)],
        callout: {
          type: "line",
          size: .5,
          color: [0, 0, 0]
        },
        verticalOffset: {
          screenLength: 40
        }
      }) : new _S({
        symbolLayers: [a.fromCIMSymbol(t)]
      });
    }
  }, {
    key: "fromTextSymbol",
    value: function fromTextSymbol(t) {
      return new _S({
        symbolLayers: [c.fromTextSymbol(t)]
      });
    }
  }]);

  return S;
}(n);

t([s({
  type: f,
  json: {
    write: !0
  }
})], d.prototype, "verticalOffset", void 0), t([s(p)], d.prototype, "callout", void 0), t([s({
  type: h,
  json: {
    type: j,
    origins: {
      "web-scene": {
        type: j
      }
    }
  }
})], d.prototype, "symbolLayers", void 0), t([y("web-scene", "symbolLayers")], d.prototype, "writeSymbolLayers", null), t([l({
  PointSymbol3D: "point-3d"
}, {
  readOnly: !0
})], d.prototype, "type", void 0), d = _S = t([i("esri.symbols.PointSymbol3D")], d);
var L = d;
export { L as default };